import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { refreshHonor, TIERS } from "@/lib/honor";
import { Switch } from "@/components/ui/switch";
import { TierPicker } from "@/components/admin/HonorTierPicker";

export const useHonorSave = (userId, name, onSaved) => {
  const [busy, setBusy] = useState(false);
  const save = async (honor, title, tier) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/users/${userId}/honor`, { honor, title, tier });
      refreshHonor().catch(() => {});
      onSaved?.(data);
      toast.success(honor ? `${name} ist Ehrenmitglied ${TIERS[data.tier].label} ✨` : "Ehrenaccount entfernt");
      return data;
    } catch (e) { toast.error(formatErr(e)); return null; } finally { setBusy(false); }
  };
  return [save, busy];
};

export const HonorAdminCard = ({ userId, name }) => {
  const [h, setH] = useState(null);
  const [title, setTitle] = useState("");
  const [tier, setTier] = useState("gold");
  const apply = (d) => { setH(d.honor); setTitle(d.title); setTier(d.tier); };
  const [save, busy] = useHonorSave(userId, name, apply);
  useEffect(() => { api.get(`/admin/users/${userId}/honor`).then(({ data }) => apply(data)).catch(() => {}); }, [userId]);
  if (h === null) return null;
  return (
    <div className={`rounded-3xl p-5 space-y-3 ${h ? `tier-${tier} honor-card` : "bg-white border border-pink-100"}`} data-testid="honor-admin-card">
      <label className="flex items-start justify-between gap-4">
        <span className="flex items-start gap-3">
          <span className="honor-chip w-10 h-10 rounded-full flex items-center justify-center shrink-0"><Award className="w-5 h-5" /></span>
          <span><span className="block text-sm font-extrabold">Ehrenaccount</span><span className="block text-xs text-slate-500">Edles Profil, glänzender Rahmen am Profilbild und „Ehrenmitglied“-Abzeichen überall</span></span>
        </span>
        <Switch checked={h} disabled={busy} onCheckedChange={(v) => save(v, title, tier)} data-testid="honor-admin-switch" />
      </label>
      <TierPicker value={tier} disabled={busy} onChange={(t) => { setTier(t); if (h) save(true, title, t); }} />
      {h && (
        <div className="flex gap-2">
          <input value={title} maxLength={60} onChange={(e) => setTitle(e.target.value)} placeholder="Ehrenmitglied der itzPlay Community" data-testid="honor-admin-title"
            className="flex-1 min-w-0 h-10 px-3 rounded-xl border border-[var(--h5)] bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[var(--h2)]" />
          <button onClick={() => save(true, title, tier)} disabled={busy} data-testid="honor-admin-title-save" className="h-10 px-4 rounded-full honor-chip text-xs font-extrabold">Titel speichern</button>
        </div>
      )}
    </div>
  );
};
